module.exports = __webpack_public_path__ + "static/media/ic_edit.e26b8e8c.svg";